const apiBase = process.env.REACT_APP_BASE_URL || "https://server.pallimarket.bd/api";
const imgUrl = process.env.REACT_APP_IMG_URL || apiBase.replace(/\/api\/?$/, "/storage");
export default imgUrl;
